import { createAPI } from '@common'
export default {
  // 删除水印
  postMamWatermarkDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0xbufsnbsl0efmfuf', 'POST', config),
  // 启用
  postMamWatermarkOpen: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0xbufsnbsl0pqfo', 'POST', config, { neverLoading: true }),
  // 禁用水印
  postMamWatermarkClose: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0xbufsnbsl0dmptf', 'POST', config, { neverLoading: true })
}
